/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_OpenInputs */

const en_recipe_shopping_open = /** @type {(inputs: Recipe_Shopping_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View list`)
};

const de_recipe_shopping_open = /** @type {(inputs: Recipe_Shopping_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Liste`)
};

/**
* | output |
* | --- |
* | "View list" |
*
* @param {Recipe_Shopping_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_open = /** @type {((inputs?: Recipe_Shopping_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_open(inputs)
	return en_recipe_shopping_open(inputs)
});